function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 102.756,
  cy: 93.1666,
  rx: 77.2441,
  ry: 72.9444,
  fill: "#67B360"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 57.5308,
  height: 10.2391,
  transform: "matrix(0.979945 0.199269 -0.181281 0.983431 68.4702 99.6666)",
  fill: "#ED3E3E"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 110.927,
  y: 9.02783,
  width: 59.1524,
  height: 88.4722,
  fill: "#F3F3F3"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 116.304,
  y: 30.6945,
  width: 12.5475,
  height: 1.80556,
  fill: "#004122"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 143.191,
  y: 30.6945,
  width: 12.5475,
  height: 1.80556,
  fill: "#004122"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 103.756,
  width: 66.3224,
  height: 14.4444,
  fill: "#004122"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 118.097,
  y: 36.1111,
  width: 14.34,
  height: 21.6667,
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 121.682,
  y: 36.1111,
  width: 10.755,
  height: 14.4444,
  fill: "#004122"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 127.059,
  y: 37.9166,
  width: 3.58499,
  height: 3.61111,
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 141.399,
  y: 36.1111,
  width: 14.34,
  height: 21.6667,
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 144.984,
  y: 36.1111,
  width: 10.755,
  height: 14.4444,
  fill: "#004122"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 150.361,
  y: 37.9166,
  width: 3.58499,
  height: 3.61111,
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M123.56 71.368L136.918 82.4069L150.275 71.368H123.56Z",
  fill: "white",
  stroke: "#004122"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 119.889,
  y: 102.917,
  width: 39.4349,
  height: 55.9722,
  fill: "#ED3E3E"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M136.022 108.333L143.783 101.563H128.26L136.022 108.333Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  width: 38.4577,
  height: 10.1752,
  transform: "matrix(0.796326 -0.604868 0.599296 0.800528 96.5864 147.845)",
  fill: "#ED3E3E"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 14.1733,
  y: 79.4445,
  width: 55.2756,
  height: 17.3333,
  fill: "#004122"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M21.2598 41.7778C21.2598 36.255 25.7369 31.7778 31.2598 31.7778H53.7794C59.3023 31.7778 63.7794 36.255 63.7794 41.7778V83.7778H21.2598V41.7778Z",
  fill: "#004122"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M54.7756 58.4999C54.7756 65.0136 49.5969 70.2777 43.2284 70.2777C36.8599 70.2777 31.6812 65.0136 31.6812 58.4999C31.6812 51.9863 36.8599 46.7222 43.2284 46.7222C49.5969 46.7222 54.7756 51.9863 54.7756 58.4999Z",
  fill: "#004122",
  stroke: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 36.8506,
  y: 91,
  width: 11.3386,
  height: 24.5556,
  fill: "#004122"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M9.92139 109.778H73.7009L58.819 169H25.5119L9.92139 109.778Z",
  fill: "#004122"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  y: 121.333,
  width: 9.92126,
  height: 44.7778,
  fill: "#004122"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 73.7007,
  y: 121.333,
  width: 9.92126,
  height: 44.7778,
  fill: "#004122"
});

function SvgKlemen7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 169,
    viewBox: "0 0 180 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlemen7);
export default __webpack_public_path__ + "static/media/klemen_7.1c4308e3.svg";
export { ForwardRef as ReactComponent };